module.exports = "https://www.gc-qa.gnp.com.mx/1162775bcf12a480c613890f388b4038.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/auto-02.svg
// module id = 8064
// module chunks = 0